// extracted by mini-css-extract-plugin
module.exports = {"Header":"hvs__Header__ChGjMbu0","HeaderH1":"hvs__HeaderH1__1c09-N2a"};